import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import DMCCPage from "@/pages/DMCCPage";
import ContactPage from "@/pages/ContactPage";
import PricingPage from "@/pages/PricingPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import EnterprisePage from "@/pages/EnterprisePage";
import UseCasesPage from "@/pages/UseCasesPage";
import SmallBusiness from "@/pages/use-cases/SmallBusiness";
import Chains from "@/pages/use-cases/Chains";
import Agencies from "@/pages/use-cases/Agencies";
import Healthcare from "@/pages/use-cases/Healthcare";
import Education from "@/pages/use-cases/Education";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/use-cases" element={<UseCasesPage />} />
          <Route path="/use-cases/small-business" element={<SmallBusiness />} />
          <Route path="/use-cases/chains" element={<Chains />} />
          <Route path="/use-cases/agencies" element={<Agencies />} />
          <Route path="/use-cases/healthcare" element={<Healthcare />} />
          <Route path="/use-cases/education" element={<Education />} />
          <Route path="/enterprise" element={<EnterprisePage />} />
          <Route path="/dmcc-compliance" element={<DMCCPage />} />
          <Route path="/contact" element={<ContactPage />} />
          {/* Placeholder routes for legal pages */}
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
